import { render, staticRenderFns } from "./partner.vue?vue&type=template&id=792c9bba&scoped=true&"
import script from "./partner.vue?vue&type=script&lang=js&"
export * from "./partner.vue?vue&type=script&lang=js&"
import style0 from "./partner.vue?vue&type=style&index=0&id=792c9bba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792c9bba",
  null
  
)

export default component.exports